import PropTypes from 'prop-types';

export const itemPropTypes = PropTypes.shape({
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  title: PropTypes.string.isRequired,
  badge: PropTypes.string.isRequired,
  details: PropTypes.object.isRequired,
}).isRequired;

export const publicUrlPropTypes = PropTypes.string.isRequired;

export const optionImagePropTypes = {
  option: PropTypes.string.isRequired,
  isSelected: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  publicUrl: PropTypes.string.isRequired,
};

export const quickViewButtonPropTypes = {
  onClick: PropTypes.func.isRequired,
};

export const productImagePropTypes = {
  onQuickView: PropTypes.func.isRequired,
  images: PropTypes.arrayOf(PropTypes.string).isRequired,
  publicUrl: PropTypes.string.isRequired,
  badge: PropTypes.string.isRequired,
  sliderRef: PropTypes.object.isRequired,
};

export const productContentPropTypes = {
  item: itemPropTypes,
  publicUrl: publicUrlPropTypes,
  selectedOption: PropTypes.string.isRequired,
  hasOverflow: PropTypes.bool.isRequired,
  onOptionClick: PropTypes.func.isRequired,
  optionsRef: PropTypes.object.isRequired,
};

export const ProductCardHome = {
  item: itemPropTypes,
  publicUrl: publicUrlPropTypes,
  onQuickView: PropTypes.func.isRequired,
};